import { BaseDto } from "@app/modules/shared/model/base.dto";

export class DefinitionDto extends BaseDto {
  public status?: string;
  public code?: string;
  public description?: string;
}
